import { ALERT_VIEWED } from 'src/app/shared/dataAnalytics/schema/constants';
import { callbackOnDifference } from 'src/app/utils/callbackOnDifference';
import type { SendTrackingEvents } from 'src/app/utils/validation';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';

import type { WarningKeywordType } from './warningKeyword';

const alertShownBasic = {
  type: 'banner',
  position: 'content',
};

const alertShownMap: Record<WarningKeywordType, Record<string, string>> = {
  restricted: {
    ...alertShownBasic,
    tone: 'critical',
    messageCode: 'remove inappropriate words',
  },
};

export const sendContentSafetyTrackingEvents = ({
  formValues,
  jobCountry,
  message,
  warningKeyword,
  warningKeywordType,
}: SendTrackingEvents) => {
  const fieldName = Object.keys(formValues || {})[0];

  // Only send tracking event when keywords grow or shrink
  // not if they stay the same....
  callbackOnDifference({
    callback: () =>
      getTrackingAdapter.sendLinkEvent({
        alertShown: [{ ...alertShownMap[warningKeywordType], message }],
        eventName: ALERT_VIEWED,
        fieldName,
        jobCountry,
        warningKeyword,
        warningKeywordType,
      }),
    data: warningKeyword,
    fieldName,
    ruleName: 'filterContent',
  });
};
